import React from 'react';
import {PendingDots} from './PendingDots';

interface LoadingOverlayProps {
  message: string;
}

/**
 * Blocking full-screen loading overlay. Dims the game behind it and swallows all clicks,
 * and presents the same dialog box the encounter overlay uses so waiting reads as part of
 * the game rather than a browser spinner.
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({message}) => (
  <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    zIndex: 100000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <div style={{
      background: '#0e2238',
      border: '2px solid #cc6633',
      borderRadius: 12,
      padding: '24px 36px',
      textAlign: 'center',
      minWidth: 280,
      maxWidth: 520,
    }}>
      <h2 style={{
        color: '#ffcc66',
        fontSize: 20,
        margin: '0 0 16px 0',
      }}>
        Please Wait
      </h2>

      {message && (
        <div style={{
          color: '#d0d0d0',
          fontSize: 14,
          lineHeight: 1.5,
          marginBottom: 16,
        }}>
          {message}
        </div>
      )}

      <PendingDots label={message || 'Loading'}/>
    </div>
  </div>
);
